import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';

import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import RegisterParticipant from './pages/RegisterParticipant';
import ParticipantsList from './pages/ParticipantsList';
import ParticipantDetail from './pages/ParticipantDetail';
import EventsList from './pages/EventsList';
import EventDetail from './pages/EventDetail';
import Organizations from './pages/Organizations';
import Events from './pages/Events';
import Categories from './pages/Categories';
import Disciplines from './pages/Disciplines';
import Results from './pages/Results';
import ResultsHome from './pages/ResultsHome';
import DisciplineResults from './pages/DisciplineResults';
import PublicRegister from './pages/PublicRegister';
import CheckIn from './pages/CheckIn';
import ActivityLog from './pages/ActivityLog';

function Shell({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  const isPublic = location.pathname.startsWith('/r/');
  if (isPublic || !user) return children;
  return <Layout>{children}</Layout>;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Shell>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/r/:eventId" element={<PublicRegister />} />

            <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />

            <Route path="/events" element={<ProtectedRoute><EventsList /></ProtectedRoute>} />
            <Route path="/events/:id" element={<ProtectedRoute><EventDetail /></ProtectedRoute>} />
            <Route path="/register" element={<ProtectedRoute roles={['admin','organization']}><RegisterParticipant /></ProtectedRoute>} />
            <Route path="/participants" element={<ProtectedRoute><ParticipantsList /></ProtectedRoute>} />
            <Route path="/participants/:id" element={<ProtectedRoute><ParticipantDetail /></ProtectedRoute>} />

            <Route path="/results" element={<ProtectedRoute><ResultsHome /></ProtectedRoute>} />
            <Route path="/results/:id" element={<ProtectedRoute><DisciplineResults /></ProtectedRoute>} />
            <Route path="/results-legacy" element={<ProtectedRoute><Results /></ProtectedRoute>} />

            <Route path="/checkin" element={<ProtectedRoute roles={['admin','reviewer']}><CheckIn /></ProtectedRoute>} />
            <Route path="/activity" element={<ProtectedRoute roles={['admin','reviewer']}><ActivityLog /></ProtectedRoute>} />

            <Route path="/organizations" element={<ProtectedRoute roles={['admin','reviewer']}><Organizations /></ProtectedRoute>} />
            <Route path="/events-legacy" element={<ProtectedRoute roles={['admin']}><Events /></ProtectedRoute>} />
            <Route path="/categories" element={<ProtectedRoute roles={['admin','reviewer']}><Categories /></ProtectedRoute>} />
            <Route path="/disciplines" element={<ProtectedRoute roles={['admin','reviewer']}><Disciplines /></ProtectedRoute>} />
          </Routes>
        </Shell>
      </BrowserRouter>
    </AuthProvider>
  );
}
